module.exports = __webpack_public_path__ + "img/back5.b75d8f82.jpg";